import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="video-modal"
// This controller shows, hides, and plays the website video
export default class extends Controller {
  static targets = [
    'image',
    'input',
    'imageContainer',
    'label',
    'video',
    'file',
    'uploaded',
    'removeBtn',
  ];
  static values = {
    form: String,
    model: String,
  };
  connect() {
    console.log('upload controller connected 6');
    console.log('formValue ->', this.formValue);
  }
  display() {
    if (this.checkSize()) {
      let type = this.checkType();
      if (type == "unknown") {
        const message = "File type not supported";
        this.stopUpload(message);
        this.labelTarget.classList.remove("hidden");
      } else {
        this.showFile(type);
      }
    }
  }

  checkSize() {
    const oneMb = 1048576;
    if (
      this.inputTarget.files[0].size > oneMb * 20
    ) {
      const message = 'File is too big! Max size is 20MB';
      this.stopUpload(message);
      return false;
    } else if (
      this.inputTarget.files[0].size > oneMb * 50
    ) {
      const message = 'Video is too big! Max size is 50MB';
      this.stopUpload(message);
      return false;
    } else {
      console.log('ok!');
      this.labelTarget.classList.add('hidden');
      return true;
    }
  }

  checkType() {
    if (this.formValue != 'material') {
      if (this.inputTarget.files[0]['type'].split('/')[0] === 'image') {
        console.log('image');
        return 'image';
      } else if (this.inputTarget.files[0]['type'].split('/')[0] === 'video') {
        console.log('video');
        return 'video';
      } else if (this.inputTarget.files[0]['type'].split('/')[0] === 'pdf') {
        console.log('pdf');
        return 'pdf';
      } else {
        console.log('else');
        return "unknown";
      }
    }
  }

  showFile(type) {
    if (type == 'image') {
      this.imageContainerTarget.classList.remove('hidden');
      this.imageTarget.src = URL.createObjectURL(this.inputTarget.files[0]);
      this.imageTarget.classList.remove('hidden');
    } else if (type == 'video') {
      this.imageContainerTarget.classList.remove('hidden');
      this.videoTarget.src = URL.createObjectURL(this.inputTarget.files[0]);
      this.videoTarget.classList.remove('hidden');
    } else {
      console.log('else');
      this.imageContainerTarget.classList.remove('hidden');
      this.fileTarget.classList.remove('hidden');
    }
  }

  stopUpload(message) {
    alert(message);
    this.inputTarget.value = '';
  }

  cancel(e) {
    e.preventDefault(); // Prevents the form from submitting
    this.labelTarget.classList.remove('hidden');
    this.imageTarget.src = '';
    this.videoTarget.src = '';
    this.inputTarget.value = '';
    this.videoTarget.classList.add('hidden');
    this.imageTarget.classList.add('hidden');
    this.fileTarget.classList.add('hidden');
    this.imageContainerTarget.classList.add('hidden');
  }

  remove(e) {
    e.preventDefault();
    this.removeBtnTarget.classList.add('hidden');
    this.labelTarget.classList.remove('hidden');
    this.uploadedTarget.src = null;
    this.uploadedTarget.classList.add('hidden');
    this.imageContainerTarget.classList.add('hidden');
  }
}
